import React from "react";
import { Container, Header } from "semantic-ui-react";

function Alumnos(props) {
  return (
    <Container>
      <Header>Listado de Alumnos con Escuelas</Header>
    </Container>
  );
}

export default Alumnos;



// WEBPACK FOOTER //
// ./src/pages/escuelas/buscadores/Alumnos.jsx